import { Directive, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[ravRouteTransformer]'
})
export class RouteTransformerDirective {
  constructor(private el: ElementRef, private router: Router) {}

  /**
   * When an anchor tag within the component using this directive is clicked, we convert the
   * route to use routerLink instead of the href so that a full browser refresh is not triggered
   */
  @HostListener('click', ['$event'])
  public onClick(event) {
    if (event.target.tagName !== 'A') return;

    this.router.navigate([event.target.getAttribute('href')]);
    event.preventDefault();
  }
}
